import { Entity, OneToMany } from 'typeorm';
import PerguntaBase from './PerguntaBase';
import Resposta from './Resposta';

@Entity()
export class Pergunta extends PerguntaBase {
  @OneToMany(() => Resposta, (resposta: Resposta) => resposta.pergunta, {
    eager: true,
    cascade: true
  })
  respostas!: Resposta[];
}

export default Pergunta;
